export const MinesGameStates = {
  Moving: "mines-is-moving",
  Flipping: "mines-is-flipping",
  Playing: "mines-is-playing",
  Idle: "mines-is-idle",
};
